// extracted by mini-css-extract-plugin
export default {"apis-result":"ApisResult_apis-result__LCm3O","result-items":"ApisResult_result-items__H46Sx","result-items_add":"ApisResult_result-items_add__xPgBW"};